// cspell:words Actvity

import { EntitlementDto, getEntitlementName } from './entitlement.dto';

/**
 * Enumeration of all feature flags the application uses.
 */
export enum Feature {
    AchAllowUnbalancedPayments = 'Feature.ACH.AllowUnbalancedPayments',
    AchFilterManagement = 'Feature.PositivePay.ACHFilterManagement',
    AchNotificationOfChangeNacha = 'Feature.ACH.NotificationOfChange.Nacha',
    AchReturnReviewNacha = 'Feature.ACH.Return.Nacha',
    AchSftpEnabled = 'Feature.Ach.Nacha.SFTP.DataTransmissions',
    AchTemplateSelectFromRecipientsList = 'AchTemplateSelectFromRecipientsList',
    AdditionalLoanDetails = 'Feature.Loan.PaymentDetails',
    ExcludeLoanLimitValidation = 'Feature.Loan.TM35475.ExcludeLoanPaymentLimitValidation',
    AgileticsEnabled = 'Feature.Product.EnableAgiletics',
    Analytics = 'MixPanelAnalytics',
    BoPositivePayPerformanceEnhancement = 'Feature.PositivePay.EnabledAccountsPerformance.3297',
    BoUserSearch = 'Feature.BackOffice.Uis.UserSearch',
    BoWireDetailCard = 'Feature.Wire.WireDetailCard',
    BrandTheme = 'Feature.BrandTheme',
    CheckExceptionV2 = 'Feature.PositivePay.CheckExceptionV2',
    CheckLookupWidget = 'CheckLookupWidget',
    CreateTransferTemplate = 'Create Template',
    CreateTransferPayment = 'Transfer, Create',
    DebugMode = 'DebugMode',
    EditProductFeature = 'Edit Product Feature',
    EulaText = 'Feature.Disclosure.EULA.TM28729',
    FdicDigitalSign = 'FdicDigitalSign',
    HasIssuedItemsClearedDate = 'Feature.AccountRecon.IssuedItems.AddClearedDateFilter.TM31553',
    HasWirePendingProcessStatus = 'Feature.Wire.Timeout.TM37819',
    ProcessXlsIssuedItemsFiles = 'Feature.Arp.ProcessXlsIssuedItemsFiles',
    IssuedItemsModification = 'Feature.PositivePay.IssuedItemModification.TM23310',
    IssuedItemSftpEnabled = 'Feature.Issued.Item.SFTP.DataTransmissions',
    IssuedItemsOdi = 'Feature.Arp.IssuedItemsViaOdi',
    IssuedItemsVoids = 'Feature.AccountRecon.IssuedItemVoids',
    HideAccountsWidgetGroupBalance = 'Feature.SupressGroupAvailBalance.AccountWidget',
    LitDomesticAch = 'Feature.ACH.DomesticPayments',
    MessageCenterEnhancement = 'Feature.MessageCenterEnhancement',
    MobileDeposits = 'MobileDeposits',
    NewBoWireDetail = 'Feature.Wire.NewWireDetail',
    PositivePayCheckExceptionAttachments = 'Feature.PositivePay.CheckException.Attachments',
    PositivePayReturnReason = 'Feature.PositivePay.ReturnReason',
    TransmitReturnReasonCode = 'Feature.TransmitReturnReasonCode.TM-35519',
    UisEnabled = 'Feature.Authentication.UIS',
    UisSecurityLevel = 'Feature.IdentitySettings.UisSecurityLevel',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    UisResetPassword = 'Feature.Authentication.UIS',
    WausauStatementsEnabled = 'WausauStatements',
    WidgetCreateAchFilterRuleButton = 'WidgetCreateAchFilterRuleButton',
    WireCreditorIsoSpeedBump = 'Feature.Wire.BeneficiarySpeedbump.ISO20022',
    WireSftpEnabled = 'Feature.Wire.SFTP.DataTransmissions',
    MixPanelProxy = 'mix-panel-proxy',
    AccountSuperUserEntitlements = 'Feature.Account.SuperUserEntitlements.TM25159',
    ChannelUseAccountNameTM6777 = 'Feature.Channel.UseAccountName.TM6777',
    SsoNavigations = 'sso-navigations',
    SaveTransferAsTemplate = 'SaveTransferAsTemplate',
    StopPaymentApproveOrReject = 'Approve Stop Payment',
    Copyright = 'Copyright',
    MemberNCUA = 'MemberNCUA',
    AccountIncludeInterestDetails = 'Feature.Account.AccountInquiry.IncludeInterestDetails',
    /**
     * Indicates that the server is using the modern .NET Core SignalR implementation.
     */
    ModernRealtime = 'net-core-signal-r',
    // PWA feature flags
    PwaMigration = 'pwa-migration',
    IsPwaBetaBank = 'IsPwaBetaBank',
    RemoteDepositManualCapture = 'Feature.PWA.RemoteDepositManualCapture',
    PwaAdminSection = 'AdminSection',
    PwaConfigureDashboard = 'ConfigureDashboard',
    PwaDashboardManageAccounts = 'ManageAccountGroups',
    PwaGetCameraPermission = 'PwaGetCameraPermission',
    PwaMitekPreload = 'PwaMitekPreload',
    PwaPaymentHub = 'PaymentHub',
    PwaCreateSingleWireManual = 'PwaCreateSingleWireManual',
    PwaWireFileActivity = 'WireFileActivity',
    PwaWireTemplatesList = 'WireTemplatesList',
    PwaWireEditCreditor = 'WiresEditCreditor',
    PwaAccountResearchTransactions = 'AccountResearchTransactions',
    PwaAchRecipientActivity = 'AchRecipientActivity',
    PwaAchTemplatesList = 'AchTemplatesList',
    PwaTransferTemplatesList = 'TransferTemplatesList',
    PwaTransferTemplateWorkflow = 'TransferTemplateWorkflow',
    PwaStopPayments = 'StopPaymentActivity',
    PwaStopPaymentsWorkflow = 'StopPaymentsWorkflow',
    PwaNotificationPreferences = 'NotificationPreferences',
    PwaTransferPaymentWidget = 'TransferPaymentWidget',
    PwaMessageCenterAdvancedFilters = 'MessageCenterAdvancedFilters',
    PwaRouteToLegacyChannel = 'RouteToLegacyChannel',
    PwaAddAnotherTransfer = 'AddAnotherTransfer',
    PwaDashboardFeatureSearch = 'DashboardFeatureSearch',
    PwaWireFileUpload = 'WireFileUpload',
    ManualCaptureFISetting = 'ManualCaptureFISetting',
    PwaReportsMenuItem = 'PwaReportsMenuItem',
    CoBrowse = 'co-browse',
}

export interface FeatureUser {
    userId: string;
    companyId?: string;
    isAdmin: boolean;
    isSuperUser: boolean;
}
/**
 * The shape of the data specified in the local `feature-flags.json` file.
 *
 * The key is the feature name.
 * The value is a binary on/off boolean or a whitelist of FI IDs to enable it for.
 */
export type LocalFeatureJson = Record<Feature, boolean | string[]>;

export enum TmFeatureType {
    /**
     * Represents the state of a Treasury Management BSL entitlement-based feature.
     */
    Entitlement,
    /**
     * Represents the state of a Treasury Management local UI-defined feature.
     */
    Local,
    /**
     * Represents the state of a Launch Darkly-defined feature flag.
     */
    LaunchDarkly,
}
export interface TmFeatureFlag {
    readonly type: TmFeatureType;
    readonly enabled: boolean;
    readonly name: Feature;
}

export interface FeatureChangedPayload {
    featureName: Feature;
    enabled: boolean;
}

export class EntitlementFeatureFlag implements TmFeatureFlag {
    constructor(
        private dto: EntitlementDto,
        public readonly enabled = true
    ) {}

    public readonly type = TmFeatureType.Entitlement;

    public readonly name = getEntitlementName(this.dto) as Feature;
}
